// assets
import Arrow from 'assets/icons/forward.svg';
import Gdot from 'assets/icons/green-dot.svg';
import Check2 from 'assets/icons/pop-check.svg';
import Rdot from "assets/icons/red-dot.svg";
import Cancel from "assets/icons/sm-x.svg";
import Back from 'assets/svg/back-arrow.svg';
import Load from "assets/svg/other/loading2.svg";
import NextIcon from "assets/svg/other/page/nextp.svg";
import Icon2 from "assets/svg/other/page/prevp.svg";
import Header from 'components/dashHeader';
import PickCountryNumber from "components/pickCountryNumber";
// components
import Sidemenu from 'components/sidemenu';
import useWindowSize from "hooks/useWindowSize";
//css 
import 'pages/styles/dashboard/Home.css';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link, useHistory } from "react-router-dom";
import { useStore } from "store";
import styled from 'styled-components';
import { get, post, put } from 'util/axiosLib';
import { logger } from "util/logger";
import { getParameterByName, isEmpty, makeCancelable, properCase, wordCut } from 'util/utils';
import { InvoiceCard } from './InvoicePage';

const receivableCoins = [
  {
    value: "btc",
    text: "BTC",
  },
  { value: "eth", text: "Ethereum" },
  { value: "xrp", text: "Ripple" },
  { value: "xlm", text: "Stellar Lumen" },
  { value: "celo", text: "CELO" },
  { value: "usdt-tron", text: "Tron" },
  { value: "eur", text: "cEUR" },
];

const pageLimit = 4;


export default function HomeReceive() {
    const { store, localsocket } = useStore();
    const history = useHistory();
    const [popUpClicked, setPopUpClicked] = useState(false);
    const [receivableUnit, setReceivableUnit] = useState(receivableCoins[0])
    const [selectedReceivingUnit, setSelectedReceivingUnit] = useState(receivableCoins[0])
    const [selectedReceivingAmount, setSelectedReceivingAmount] = useState();
    const [payer, setPayer] = useState({firstName: "", lastName: "", email: "", description: "", phoneNumber: ""})
    const [scheduleFor, setScheduleFor] = useState({dueIn: "", durationUnit: ""});
    const [dueAt, setDueAt] = useState({dueIn: "", durationUnit: ""});
    const [error, setError] = useState({otherError: "", incorrectError: ""});
    const [showSummary, setShowSummary] = useState(false);
    const [countryCode, setCountryCode] = useState('234');
    const [transactionsView, setTransactionsView] = useState("received");
    const [transactionsLoading, setTransactionsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [txCount, setTxCount] = useState(0);
    const [allTx, setAllTx] = useState([]);
    const [txCache, setTxCache] = useState({});
    const [actionInProgress, setActionInProgress] = useState(false);
    const cancelableFetch = useRef();
    const cancelableFetchReceivable = useRef();
    const { width: windowWidth } = useWindowSize();
    const [receiveView, setReceiveView] = useState('create');
    const [invoiceData, setInvoiceData] = useState({});
    const [pageState, setPageState] = useState("loading");

    const wordLen = useMemo(() => {
      return isNaN(windowWidth)
        ? 50
        : Math.max(50, Math.floor(Number(windowWidth) / 8)); 
    }, [windowWidth]);

    const invoiceRef = useRef(getParameterByName('iv', history.location.search));

    useEffect(() => {
      if (isEmpty(invoiceRef.current)) {
        setReceiveView("create");
      } else {
        cancelableFetchReceivable.current &&
          cancelableFetchReceivable.current.cancel();
        setReceiveView("viewing");
        cancelableFetchReceivable.current = makeCancelable(fetchReceivable());
      }
      return () => {
        cancelableFetchReceivable.current = makeCancelable(fetchReceivable());
      };
      // eslint-disable-next-line
    }, [invoiceRef.current, history.location.search])


    const fetchReceivable = async () => {
      try {
        const token = store.token;
        const headers = {
          authorization: `${token}`,
          "Content-Type": "application/json",
        };

        if (isEmpty(invoiceRef.current)) {
          return setPageState("notFound");
        }

        const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}/wallet/invoice/${invoiceRef.current}`;

        const getTransactionsReq = await get(baseUrl, headers);

        const rawTx = getTransactionsReq?.data?.data;

        setInvoiceData({ ...rawTx, lastFectched: new Date() });
        // await getCurrentRate();
        setPageState("ready");
      } catch (err) {
        if (err?.isAxiosError) {
          if (err?.response?.status === 401) {
            return localsocket && localsocket?.emit("LOGOUT");
          } else if (err?.response?.status === 403) {
            return setPageState("notFound");
          } else if (err?.response?.status === 404) {
            return setPageState("notFound");
          }
        } else {
          logger("ERROR:: ", err);
        }
        setPageState("error");
        // setTransactionError(String(err))
      }
    };

    const fetchReceivables = async () => {
      try {
        const token = store.token;
        const headers = {
          authorization: `${token}`,
          "Content-Type": "application/json",
        };
        // 'open', 'cancelled', 'closed', 'timeout'
        const whichState = transactionsView === 'received' ? 'closed,cancelled,timeout' : transactionsView === 'pending' ? 'open' : 'scheduled';
        
        if (!isEmpty(txCache[`${whichState}/${currentPage}/data`])) {
          setAllTx(txCache[`${whichState}/${currentPage}/data`]);
          setTxCount(txCache[`${whichState}/${currentPage}/count`]);
          return;
        }
        
        const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}/wallet/invoice/own?state=${whichState}&limit=${pageLimit}&page=${currentPage}`;
        setTransactionsLoading(true);
        
        const getTransactionsReq = await get(
            baseUrl,
            headers
        );

        const rawTx = getTransactionsReq?.data?.data;
        const receivedTx = rawTx?.invoices;

        const newTx = Array.isArray(receivedTx)
          ? receivedTx
          : Array.from(receivedTx);
          const newTxCount = isNaN(rawTx?.totalCount)
            ? 0
            : Number(rawTx?.totalCount);

        setAllTx(newTx);
        setTxCount(newTxCount);
        setTransactionsLoading(false);
        setTxCache({
          ...txCache,
          [`${whichState}/${currentPage}/data`]: newTx,
          [`${whichState}/${currentPage}/count`]: newTxCount, 
        })
      } catch(err) {     
        if (err?.isAxiosError) {
          if (err?.response?.status === 401) {
                return localsocket && localsocket?.emit("LOGOUT")
            }
          } else {
              logger("ERROR:: ", err);
          }
        setTransactionsLoading(false);
        // setTransactionError(String(err))
      }
    }

    const cancelReceivable = async(tradeId) => {
      if (!tradeId) return; // show some notification here
      try {
        const baseUrl = process.env.REACT_APP_API_ENDPOINT;

        const token = store.token;
        const headers = {
          authorization: `${token}`,
          "Content-Type": "application/json",
          "Cache-Control": "no-cache",
        };

        const url = `${baseUrl}/wallet/invoice/${tradeId}/cancel`;

        setActionInProgress(true)

        await put(url,{}, headers);
        setTxCache({})
        
        //  refetch data
        refresh();

        setActionInProgress(false);
      } catch (err) {
        setActionInProgress(false);
        logger(err);
      }
    }

    useEffect(() => {
      cancelableFetch.current = makeCancelable(fetchReceivables());

      return () => {
        cancelableFetch.current && cancelableFetch.current.cancel();
      };
      // eslint-disable-next-line
    }, [transactionsView, currentPage])

    const refresh = () => {
      fetchReceivables()
    }

    const handleSubmit = async (event) => {
      setError({ otherError: "", incorrectError: "" });
      try {
        event && event?.preventDefault();
        if (!inputState.check) {
          return;
        } 

        const payload = {};
        payload.payer = {...payer, phoneNumber: `+${countryCode}${payer.phoneNumber}`};
        payload.unitReceiving = receivableUnit.value;
        payload.useCurrentRate = false // hardcoding until option is available on ui
        if(selectedReceivingUnit.value === 'usd') {
          payload.amountInDollars = selectedReceivingAmount;
          payload.useCurrentRate = true;
        }
        else {
          payload.amount = Number(selectedReceivingAmount);
        }
        if(scheduleFor?.dueIn) {
          payload.scheduleFor = {
            ...scheduleFor
          }
        }
        if(dueAt?.dueIn) {
          payload.dueAt = {
            ...dueAt
          }
        }
        
        if(!showSummary) {
           setShowSummary(true);
           return;
        } 

        const headers = {
          authorization: `${store.token}`,
          "Content-Type": "application/json",
        };
        
        const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/wallet/invoice/create`;

        const sendReq = await post(endpoint, payload, headers);
        
        if (sendReq?.data?.status === "success") {
          setShowSummary(false);
          setPopUpClicked(true);

          if (transactionsView === "pending") {
            setCurrentPage(1);
            setTransactionsLoading(true);
          }

          // clear cache
          setTxCache({
            ...txCache,
            [`open/1/data`]: [],
            [`open/1/count`]: 0,
          });

          if (transactionsView === "pending") {
            await refresh();
            setTransactionsLoading(false);
          }
        } 

        if(2 + 2 === 5) {
          setDueAt({});
          setScheduleFor({});
        }
      } catch (err) {
        logger("POST RECEIVABLE ERROR::: ", err);

        if (err?.isAxiosError) {
          const errData = err.response;

          if (err?.response?.status === 401) {
              return localsocket && localsocket?.emit("LOGOUT");
          } else {
            logger("ERROR:: ", err);
          }

          setError({
            incorrectError: errData?.data?.error || "Something went wrong",
          });
          
        } else {
          setError({ otherError: "Something went wrong" });
        }
      }
    }

    const handleRemove = event => {
        event?.preventDefault();

       setPopUpClicked(false);
        // setTimeout(function(){ 
        //     document.querySelector('#rem-box').style.display = "none" 
        // }, 1000);
    }

    const handleCountryPicker = (countryCode) => {
      if(countryCode) setCountryCode(countryCode)
    }

    const stPages = useMemo(() => {
      return isNaN(txCount) ? 1 : parseInt(Number(txCount - 1) / pageLimit) + 1;
    }, [txCount]);

    const nextPages = () => {
      if (currentPage < stPages) setCurrentPage(currentPage + 1);
    };
    
    const prevPages = () => {
      if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const inputState = useMemo(() => {
      const checkStatus = {check: true, field: {}};
      if(!receivableUnit.value) {
        checkStatus.check = false;
        checkStatus.field = {receivableUnit: "Receiving unit is required"}
      } 
      if(!selectedReceivingUnit.value) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          selectedReceivingUnit: "Select the unit to receive in",
        };
      } 
      if(!selectedReceivingAmount) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          selectedReceivingAmount: "Amount to receive is required",
        };
      } else if (typeof selectedReceivingAmount <= 0) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          selectedReceivingAmount: "Amount to receive must be greater than 0",
        };
      }
      if(!payer?.firstName) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          firstName: "Sender's firstname is required"
        };
      }
      if(!payer?.lastName) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          lastName: "Sender's lastName is required"
        };
      }
      if(!payer?.phoneNumber) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          phoneNumber: "Sender's phone number is required"
        };
      }
      if(!payer?.email) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          email: "Sender's email address is required"
        };
      }
      if(!payer?.description) {
        checkStatus.check = false;
        checkStatus.field = {
          ...checkStatus.field,
          firstName: "Invoice note is required"
        };
      }
      return checkStatus;
    }, [receivableUnit.value, selectedReceivingUnit.value, selectedReceivingAmount, payer.firstName, payer.lastName, payer.email, payer.phoneNumber, payer.description])

        const currentPageView = "Home";
        // const isViewing = !isEmpty(invoiceRef);

        return (
          <StyledDiv>
            <Sidemenu currentPage={currentPageView} />
            <Header />

            {popUpClicked ? (
              <div id="rem-box">
                <div className="overlay animate__animated animate__fadeIn "></div>
                <section className="popup">
                  <div className="popup-box animate__animated animate__slideInDown">
                    <div className="popup-img">
                      <img
                        className=" animate__animated animate__slow animate__jackInTheBox animate__delay-.5s"
                        src={Check2}
                        alt=""
                      />
                    </div>
                    <h2>
                      {Number(selectedReceivingAmount).toLocaleString()}{" "}
                      {String(selectedReceivingUnit.value).toUpperCase()}
                    </h2>
                    <p className="popup-success">Receive Request Successful</p>
                    <p onClick={handleRemove} className="popup-close">
                      Close
                    </p>
                    {/* {document.querySelector('#rem-box').style.display = "block"} */}
                  </div>
                </section>
              </div>
            ) : null}

            {showSummary ? (
              <div>
                <div className="overlay animate__animated animate__fadeIn "></div>
                <section className="summaryclicked">
                  <div className="summaryclicked-box animate__animated animate__slideInUp">
                    <div className="sc-top">
                      <h2 className="">Summary</h2>
                      <img
                        onClick={() => setShowSummary(false)}
                        src={Cancel}
                        alt="close"
                      />
                    </div>
                    <div className="sc-items">
                      <p className="sc-item-title"> Receiving Coin</p>
                      <p className="bold">{String(receivableUnit.text)}</p>
                    </div>
                    <div className="sc-items">
                      <p className="sc-item-title"> Quantity </p>
                      <p className="bold">
                        {Number(selectedReceivingAmount).toLocaleString()}{" "}
                        {String(selectedReceivingUnit.value).toUpperCase()}
                      </p>
                    </div>

                    <div className="sc-items-last">
                      <p className="sc-item-title"> Sender First Name</p>
                      <p className="bold"> {payer.firstName} </p>
                    </div>
                    <div className="sc-items-last">
                      <p className="sc-item-title"> Sender Last Name</p>
                      <p className="bold"> {payer.lastName} </p>
                    </div>
                    <div className="sc-items-last">
                      <p className="sc-item-title"> Sender Email</p>
                      <p className="bold"> {payer.email} </p>
                    </div>
                    <div className="sc-items-last">
                      <p className="sc-item-title"> Sender Phone Number</p>
                      <p className="bold">
                        {" "}
                        {`+${countryCode}${payer.phoneNumber}`}{" "}
                      </p>
                    </div>

                    <button
                      onClick={handleSubmit}
                      className="summaryclicked-btn"
                    >
                      Submit
                    </button>
                    <div
                      id="error-info"
                      className="error-info animate__animated animate__fadeIn"
                    >
                      <p>{error?.errorMessage}</p>
                    </div>
                  </div>
                </section>
              </div>
            ) : null}

            <section className="home">
              <div className="home-container">
                <div className="home-buy-content">
                  <Link to="/dashboard/home">
                    <img src={Back} className="w-backarrow" alt="back" />
                  </Link>
                  <h1> Receive </h1>
                  <div className="home-nav">
                    <Link to="/dashboard/home" className="right-e">
                      <p className="ash"> Home </p>{" "}
                    </Link>
                    {/* Breadcrumbs  */}
                    {receiveView === "viewing" ? (
                      <>
                        <img className="right-e" src={Arrow} alt="" />
                        <Link to="/dashboard/homereceive" className="right-e">
                          <p className="ash" onClick={() => {
                            invoiceRef.current = null;
                          }}> Receive </p>{" "}
                        </Link>
                        <img className="right-e" src={Arrow} alt="" />
                        <p>
                          <span className="bold">
                            {" "}
                            Viewing "#{invoiceRef.current}"{" "}
                          </span>
                        </p>
                      </>
                    ) : (
                      <>
                        <img className="right-e" src={Arrow} alt="" />
                        <p>
                          <span className="bold"> Receive</span>
                        </p>
                      </>
                    )}
                    {/* End breadcrumbs  */}
                  </div>

                  <div className="hr-boxes">
                    {/* Create a new invoice form  */}
                    <div className={`hr-box-bg right-m0 ${receiveView === 'viewing' ? 'viewing' : ''}`} style={{overflowY: 'auto'}}>
                      {receiveView === "viewing" ? (
                        <InvoiceCard
                          invoiceData={invoiceData}
                          pageState={pageState}
                          setInvoiceData={setInvoiceData}
                          setPageState={setPageState}
                          homeReceive
                          handleCancel={() => cancelReceivable(invoiceData?.ref)}
                        />
                      ) : (
                        <form
                          onSubmit={handleSubmit}
                          className="receivable-form"
                        >
                          {/* <h2 class="line-aside">Payment Info</h2> */}
                          <div className="receiver-area flex gap-4">
                            <div className="receiving-unit hw-inputs">
                              <p className="hr-txt">Receiving Unit</p>
                              <select
                                className="hw-drop"
                                defaultValue="btc"
                                onChange={({ target }) => {
                                  const { selectedIndex } = target;
                                  setReceivableUnit(
                                    receivableCoins[selectedIndex]
                                  );
                                  if (selectedReceivingUnit.value !== "usd") {
                                    setSelectedReceivingUnit(
                                      receivableCoins[selectedIndex]
                                    );
                                  }
                                }}
                              >
                                {receivableCoins.map((coin) => (
                                  <option key={coin.value} value={coin.value}>
                                    {coin.text}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div className="receiving-amount">
                              <p className="hr-txt">Amount to receive</p>
                              <div className="hw-double-inputs">
                                <select
                                  className="hw-drop"
                                  defaultValue={
                                    receivableUnit?.value
                                      ? receivableUnit.value
                                      : "usd"
                                  }
                                  onChange={({ target }) => {
                                    const { selectedIndex } = target;
                                    let sel = { text: "USD", value: "usd" };
                                    if (selectedIndex === 1)
                                      sel = receivableUnit;
                                    setSelectedReceivingUnit(sel);
                                  }}
                                >
                                  <option value="usd" data-name="USD">
                                    USD
                                  </option>
                                  <option
                                    value={receivableUnit?.value}
                                    data-name={receivableUnit?.value?.toUpperCase()}
                                  >
                                    {receivableUnit?.value?.toUpperCase()}
                                  </option>
                                </select>
                                <input
                                  type="number"
                                  placeholder="Quantity"
                                  name="coinAmount"
                                  onChange={({ target }) =>
                                    setSelectedReceivingAmount(target.value)
                                  }
                                />
                              </div>
                            </div>
                          </div>

                          <div className="mt-8 mb-4">
                            <h2 className="line-aside">Sender's Info</h2>
                          </div>

                          <div className="flex gap-4 divide-half mt-4">
                            <div className="hw-inputs">
                              <p className="hr-txt">First Name</p>
                              <input
                                type="firstName"
                                placeholder="Sender First Name"
                                required
                                onChange={({ target }) => {
                                  setPayer({
                                    ...payer,
                                    firstName: properCase(target.value),
                                  });
                                }}
                              />
                            </div>
                            <div className="hw-inputs">
                              <p className="hr-txt">Last Name</p>
                              <input
                                type="lastName"
                                placeholder="Sender Last Name"
                                required
                                onChange={({ target }) => {
                                  setPayer({
                                    ...payer,
                                    lastName: properCase(target.value),
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="flex flex-row-dynamic gap-4 divide-half mt-4">
                            <div className="hw-inputs">
                              <p className="hr-txt">Email</p>
                              <input
                                type="email"
                                placeholder="Sender Email Address"
                                required
                                onChange={({ target }) =>
                                  setPayer({ ...payer, email: target.value })
                                }
                              />
                            </div>
                            {/* <div className="hw-inputs">
                            <p className="hr-txt">Phone number </p>
                            <input type="text" placeholder="Phone Number" />
                          </div> */}

                            <div className="hw-inputs custom-number-pick">
                              <p className="hr-txt">Phone Number</p>
                              <PickCountryNumber
                                handleCountryPicker={handleCountryPicker}
                                defaultCode={`+${countryCode}`}
                              />
                              <input
                                id="phonenumber"
                                name="phone"
                                className="su-single-inputs number-pick"
                                type="tel"
                                placeholder="Phone number"
                                maxLength="14"
                                // value={this.state.phone}
                                // onChange={this.handleInputCheck}
                                required
                                onChange={({ target }) => {
                                  setPayer({
                                    ...payer,
                                    phoneNumber: target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>

                          <div className="hw-inputs mt-4">
                            <p className="hr-txt mt-4">Note</p>
                            <textarea
                              onChange={({ target }) => {
                                setPayer({
                                  ...payer,
                                  description: target.value,
                                });
                              }}
                            ></textarea>
                          </div>
                          <div className="flex justify-center gap-6">
                            <button
                              // disabled={!inputState.check}
                              type="submit"
                              className="hr-btn-s mt-4"
                            >
                              Create Invoice
                            </button>
                            {false && (
                              <div
                                // disabled={!inputState.check}
                                type="submit"
                                className="hr-btn-s mt-4"
                              >
                                Schedule Invoice
                              </div>
                            )}
                          </div>
                        </form>
                      )}
                    </div>
                    {/* End create new invoice  */}
                    <div className="hr-box-sm">
                      <div className="wtb-top">
                        <h3> Recent transactions </h3>
                      </div>
                      {/* Tranasaction tabs */}
                      <div className="tab-wrapper">
                        <div className="p2p-types-tabs">
                          <div
                            className={`p2p-type right-m0 ${
                              transactionsView === "received"
                                ? "type-active"
                                : ""
                            }`}
                            onClick={() => {
                              setTransactionsView("received");
                            }}
                          >
                            <p>Closed</p>
                          </div>
                          <div
                            className={`p2p-type ${
                              transactionsView === "pending"
                                ? "type-active"
                                : ""
                            }`}
                            onClick={() => {
                              setTransactionsView("pending");
                            }}
                          >
                            <p>Pending</p>
                          </div>
                          {false && (
                            <div
                              className={`p2p-type ${
                                transactionsView === "scheduled"
                                  ? "type-active"
                                  : ""
                              }`}
                              onClick={() => {
                                setTransactionsView("scheduled");
                              }}
                            >
                              <p>Scheduled</p>
                            </div>
                          )}
                        </div>
                      </div>

                      {transactionsLoading ? (
                        <>
                          {/* Is loading  */}
                          <div className="loading-a" id="load">
                            <img src={Load} alt="loading" />
                          </div>
                        </>
                      ) : !allTx?.length ? (
                        <>
                          {/* No record  */}
                          <div className="wtb-single2">
                            <p className="wtb-title"> No record</p>
                          </div>
                        </>
                      ) : (
                        <>
                          {transactionsView === "received" &&
                            allTx.map((tx) => (
                              <div
                                className="tx-single__wrap"
                                key={tx?._id}
                                onClick={() => {
                                  history.push(
                                    `/dashboard/homereceive?iv=${tx?.ref}`
                                  );
                                  invoiceRef.current = tx?.ref;
                                }}
                              >
                                <div className="wtb-single" key={tx?._id}>
                                  <div className="wtb-single-info">
                                    {tx?.receivableState === "closed" ? (
                                      <img
                                        className="right-m1"
                                        src={Gdot}
                                        alt=""
                                      />
                                    ) : (
                                      <img
                                        className="right-m1"
                                        src={Rdot}
                                        alt=""
                                      />
                                    )}
                                    <div className=".wtb-single-desc">
                                      <p className="wtb-title">
                                        {tx?.receivableState === "closed"
                                          ? `Received ${tx?.payer?.amountReceivable} `
                                          : `${tx?.receivableState.toUpperCase()} `}
                                        {String(
                                          tx?.addressData?.coin
                                        ).toUpperCase()}{" "}
                                      </p>
                                      <p className="wtb-date">
                                        {tx?.createdAt?.substr(0, 10)}
                                      </p>
                                      <p className="mt-4 wtb-ref">
                                        <em>Ref:</em> {` ${tx?.ref}`}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="wtb-single-amount sender-user">
                                    <p className="bold">FROM</p>
                                    <div className="sender-name">{`${tx.payer?.user?.firstName}, ${tx?.payer?.user?.lastName}`}</div>
                                    <div className="sender-name">{`${tx?.payer?.user.email}`}</div>
                                  </div>
                                </div>
                                <p className="tx-desc">
                                  {wordCut(
                                    tx?.payer?.user?.description,
                                    wordLen,
                                    " ..."
                                  )}
                                </p>
                              </div>
                            ))}
                          {transactionsView === "pending" &&
                            allTx.map((tx) => (
                              <div
                                className="tx-single__wrap"
                                key={tx?._id}
                                onClick={() => {
                                  history.push(
                                    `/dashboard/homereceive?iv=${tx?.ref}`
                                  );
                                  invoiceRef.current = tx?.ref;
                                }}
                              >
                                <div className="wtb-single">
                                  <div className="wtb-single-info">
                                    <img
                                      className="right-m1"
                                      src={Gdot}
                                      alt=""
                                    />
                                    <div className=".wtb-single-desc">
                                      <p className="wtb-title">
                                        Invoice of{" "}
                                        {tx?.payer?.amountInDollars ||
                                          tx?.payer?.amountReceivable}{" "}
                                        {tx?.payer?.amountInDollars
                                          ? "USD"
                                          : String(
                                              tx?.addressData?.coin
                                            ).toUpperCase()}{" "}
                                      </p>
                                      <p className="wtb-date">
                                        {tx?.createdAt?.substr(0, 10)}
                                      </p>
                                      <p className="mt-4 wtb-ref">
                                        <em>Ref:</em> {` ${tx?.ref}`}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="wtb-single-amount sender-user">
                                    <p className="bold">FROM</p>
                                    <div className="sender-name">{`${tx.payer?.user?.firstName}, ${tx?.payer?.user?.lastName}`}</div>
                                    <div className="sender-name">{`${tx?.payer?.user.email}`}</div>
                                  </div>

                                  <div className="pts-box">
                                    <button
                                      onClick={() => {
                                        if (!actionInProgress) {
                                          cancelReceivable(tx?.ref);
                                        }
                                      }}
                                      disabled={!!actionInProgress}
                                      className="pts-cancel red"
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>

                                <p className="tx-desc">
                                  {wordCut(
                                    tx?.payer?.user?.description,
                                    wordLen,
                                    " ..."
                                  )}
                                </p>
                              </div>
                            ))}
                        </>
                      )}
                      {!transactionsLoading && txCount > pageLimit ? (
                        <div className="paginate-box mt-4">
                          <p className="pts-max">
                            {`Page ${currentPage} of ${stPages}`}
                          </p>
                          <div className="paginate-actions">
                            {currentPage >= 2 && (
                              // <button onClick={this.prevPages}>Prev</button>
                              <img
                                className="paginate-arrows flip"
                                src={NextIcon}
                                onClick={prevPages}
                                alt="prev"
                              />
                            )}
                            {currentPage <= 1 && (
                              // <button onClick={this.prevPages}>Prev</button>
                              <img
                                className="paginate-dis"
                                src={Icon2}
                                alt="prev"
                              />
                            )}

                            {currentPage < stPages && (
                              <img
                                className="paginate-arrows"
                                src={NextIcon}
                                onClick={nextPages}
                                alt="next"
                              />
                            )}
                            {parseInt(currentPage) === parseInt(stPages) && (
                              <img
                                className="paginate-dis flip"
                                src={Icon2}
                                alt="next"
                              />
                            )}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </StyledDiv>
        );
    
}

export var StyledDiv = styled.div`
.hr-box-bg.viewing {
  display: unset;
  max-height: 42rem;
}
.tx-single__wrap {
    cursor: pointer;
    &:hover,
    &:active {
      border: 0.5px solid green;
      border-radius: 8px;
    }
    .wtb-single {
      border-bottom: unset;
    }
    border-bottom: 1px solid #eaeaeaa9;
    &:hover {
      border-bottom: 1px solid #008000bf;
    }
    .tx-desc {
      padding: 0.5em 0 1rem 1.2rem;
      opacity: 0.75;
      font-size: 0.8rem;
    }
    .wtb-title {
      font-weight: 700;
      font-size: 0.8rem;
    }
  }
.pts-cancel {
    background: white;
    border: unset;
}
div.hr-btn-s {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 0.8em;
} 
.hr-btn-s{
  @media (min-width: 1270px) {
    max-width: 250px;
  }
}
.hr-box-sm {
  overflow: hidden;
}
.wtb-single2 {
  display: grid;
  place-content: center;
  margin-top: 2rem;
}
.loading-a {
    width: 100%;
    left: 0;
    position: relative;
    height: 4em;
    padding: 1em;
    font-size: 0.9em;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;

    &.actioning {
      opacity: 0.75;
      padding: unset;
      height: unset;
    }
  }
.sender-user {
  flex-basis: 40%;
  letter-spacing: 1.4;
}
.wtb-ref {
    font-size: 0.75rem;
    color: #1e90ff;
    mix-blend-mode: normal;
}
.tab-wrapper {
  width: 100%;
  overflow-x: auto;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 1px;
    // background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }

  &::-webkit-scrollbar,
  &::-webkit-scrollbar {
      width: 2px !important;
      height: 4px;
    }
  }

  .divide-half {
    display: flex;
    gap: 1rem;
    & > div {
      flex-basis: 50%;
    }
  }
  .line-aside {
    font: 1rem sans-serif;
    margin-bottom: 0.5rem
    margin-top: 0.5rem;
    text-align: center;
    text-transform: uppercase;
    display: table;
    white-space: nowrap;
    &:before,
    &:after {
      border-top: 1px solid green;
      content: "";
      display: table-cell;
      position: relative;
      top: 0.5em;
      width: 45%;
    }
    &:before {
      right: 1.5%;
    }
    &:after {
      left: 1.5%;
    }
  }
  .receivable-form {
    width: 100%;

    .receiver-area {
      display: flex;
      gap: 1rem;

      .receiving-unit {
        flex-basis: 50%;
        @media (max-width: 500px) {
         flex-basis: 100%
        }
      }
      
      .receiving-amount {
        flex-basis: 50%;
        .hw-double-inputs {
          width: 100%;
        }
        select {
          width: 37%;

          @media (min-width: 1520px) {
            width: 31%;         
          }
          @media (max-width: 1440px) {
            width: 39%;         
          }
          @media (max-width: 1020px) {
            width: 38%;         
          }
          @media (max-width: 800px) {
            width: 35%;         
          }
          @media (max-width: 500px) {
            width: 37%;         
          }
          @media (max-width: 400px) {
            width: 36%;         
          }
          
        }
        input {
          width: 75%;
        }
        .hw-drop {
          margin-right: -2rem;
          z-index: 5;
        }
        @media (max-width: 500px) {
         flex-basis: 100%
        }
      }

      @media (max-width: 500px) {
         flex-flow: column;         
        }
    }

    .custom-number-pick {
      .pc3-section {
        position: relative;
        .pc-box3 {
          top: 10px;
          left: 6px;
          overflow: hidden;
        }
      }
    }

    .hw-inputs {
      margin: unset;
      input,
      select,
      textarea {
        width: 100%;
      }
    }
    .su-single-inputs {
      &.number-pick {
        width: 100%;
      }
    }
  }
`;


